/* eslint-disable @typescript-eslint/no-explicit-any */
interface ObjectFieldProps {
  key: string;
  title: string;
  value: () => any;
}

export class ObjectField {
  key!: string;
  title!: string;
  value!: () => any;

  constructor(props: ObjectFieldProps) {
    this.key = props.key;
    this.title = props.title;
    this.value = props.value;
  }

  static for(key: string, title: string, value: () => any) {
    return new ObjectField({
      key,
      title,
      value,
    });
  }
}
